export const positionValues = {
    relative: 'relative'
}

export const floatDirection = {
    right: 'right',
    left: 'left'
}

export const clearValues = {
    both: 'both'
}

export const textAlignValues = {
    right: 'right',
    left: 'left',
    center: 'center'
}

export const overflowValues = {
    visible: 'visible'
}

export const WebkitAppearanceValues = {
    none: 'none'
}

